import { api } from '@/lib/api';
import AdForm from '@/pages/dashboard/AdForm';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { VerificationBanner } from '@/components/common/VerificationBanner';

export default function NewAdPage() {
    const submit = async (payload) => {
        const { data } = await api.post('/ads', payload);
        return data;
    };
    return (
        <div className="space-y-4">
            <h1 className="text-xl font-semibold tracking-tight">Nuevo anuncio</h1>
            <VerificationBanner />
            <ErrorBoundary>
                <AdForm onSubmit={submit} submitLabel="Publicar anuncio" />
            </ErrorBoundary>
        </div>
    );
}
